export {default} from './TermsOfService'
